/* RESPONSIBLE TEAM: team-messenger */
import Model, { attr } from '@ember-data/model';

// Default values matching CustomResponseDelayHelper (Ruby).
// See: intercom/app/helpers/custom_response_delay_helper.rb
/* eslint-disable @intercom/intercom/no-bare-strings */
export const DEFAULT_CUSTOM_RESPONSE_TIME_VALUES: { text: string; value: number }[] = [
  { text: '1 minute', value: 60 },
  { text: '2 minutes', value: 120 },
  { text: '3 minutes', value: 180 },
  { text: '4 minutes', value: 240 },
  { text: '5 minutes', value: 300 },
  { text: '10 minutes', value: 600 },
  { text: '15 minutes', value: 900 },
  { text: '20 minutes', value: 1200 },
  { text: '30 minutes', value: 1800 },
  { text: '1 hour', value: 3600 },
  { text: '2 hours', value: 7200 },
  { text: '3 hours', value: 10800 },
  { text: '4 hours', value: 14400 },
  { text: '5 hours', value: 18000 },
  { text: '6 hours', value: 21600 },
  { text: '12 hours', value: 43200 },
  { text: '1 day', value: 86400 },
  { text: '2 days', value: 172800 },
  { text: '3 days', value: 259200 },
  { text: '4 days', value: 345600 },
  { text: '5 days', value: 432000 },
  { text: '6 days', value: 518400 },
  { text: '1 week', value: 604800 },
];
/* eslint-enable @intercom/intercom/no-bare-strings */

export default class TeamSetting extends Model {
  @attr('string') declare appId: string;
  @attr('string') declare teamId: string;
  @attr('boolean') declare volumeControlEnabled: boolean;
  @attr('string') declare distributionMethod: string;
  @attr() declare order: number;
  @attr('string') declare officeHoursScheduleId: string;
  @attr('boolean', { defaultValue: false }) declare teamResponseDelayEnabled: boolean;
  @attr('number', { defaultValue: 3 }) declare customResponseDelay: number;
  @attr() declare customResponseDelayValue: number;
  @attr({ defaultValue: () => DEFAULT_CUSTOM_RESPONSE_TIME_VALUES })
  declare customResponseTimeValues: { text: string; value: number }[];
  @attr('number') declare assignmentLimit: number;
}
